export enum SurveyActionTypeEnum {
    DisplaySurvey,
    DisplaySurveyReadOnly,
    HideSurvey,
    DisplayQuestions,
}